/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Enpp.Map <br/>
/// Code from: https://openstreetmap.be/en/projects/howto/openlayers.html
///
/// <br/>
/// Author: ARF<br />
/// Date: 21.4.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 27.4.2022                                                *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.EnppMap", $.common.VisualBase, {
    data: null,
    fullInformation: null,
    date: null,
    periodWidthDefault: 210,
    bInit: false,
    bShowBaseline: false,
    _create: function () {
        var me = this;
        try {

            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 337;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {

            me.showMessage("", false);
            me._getMap();

            return false;


        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _getMap: function () {
         /// <summary>
        /// This function generates a list of map features from the logger list and shows an OpenLayer map
        /// </summary>
        var me = this;
        var lstFeatures = [];
        try {

           
            var fullInfo = JSON.parse(me.specific.fullInformation);
          
            //generates the features
            $.each(fullInfo.LoggerList, function (i, l) {
                var feature = new ol.Feature({ name: l.Name, blid: l.Id,geometry: new ol.geom.Point(ol.proj.transform(l.LonLat, "EPSG:4326", "EPSG:3857"))});
                var style = new ol.style.Style({
                    image: new ol.style.Icon({
                        anchor: [0,-0.5], size: [23, 30], scale: 0.5,
                        src: '../../images/map-marker.png'
                    }),
                    text: new ol.style.Text({ text: feature.get('name'), font: '12px Verdana', fill: new ol.style.Fill({ color: '#004b79' }) })
                })
                feature.setStyle(style);
                lstFeatures.push(feature);
              
            });
           
            var vectorSource = new ol.source.Vector({features:lstFeatures});
            var projectLayer = new ol.layer.Vector({ source: vectorSource });
            //get the base layer
            var baseLayer = new ol.layer.Tile({  source: new ol.source.XYZ({ url: 'https://s.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png' }) });
            var map = new ol.Map({ // we create our map
                layers: [baseLayer, projectLayer], // and add the layers to it 
                target: "divVC" + me.vcgid, // the div element that will serve as a map
                controls: ol.control.defaults({  attributionOptions: /** @type {olx.control.AttributionOptions} */ ({ collapsible: true}) }),
                view: new ol.View({ maxZoom: 17 })
            });

            map.getView().fit(vectorSource.getExtent(), { size: map.getSize(), padding: [10, 0, 10, 0]});

            // display popup on click
            //map.on('click', function (evt) {

            //    var feature = map.forEachFeatureAtPixel(evt.pixel,
            //        function (feature, layer) {
            //            return feature;
            //        });
            //    if (feature) {
                 
            //        //console.info(feature.values_);
                  
            //    }
            //});



        } catch (e) {
            me.writeError('_getMap', e);
            return false;
        }
        return true;
    },


    _initEvents: function () {
        var me = this;
        try {

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },





    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});

